export enum InvoiceArPrepaymentStatusEnum {
  PAID = "PAID",
  UNPAID = "UNPAID",
  CANCELLED = "CANCELLED",
  UN_APPLIED = "UN_APPLIED",
  APPLIED = "APPLIED",
}
